import API from "./API";

export default class PaymentTypeAPI extends API {
  constructor(parameters = {}) {
    super("/PaymentType", parameters);
  }
}
